module.exports = __webpack_public_path__ + "img/deposit-credit.b7ae9254.svg";